import type { Item } from "../common";

export enum MarketingNarrativesFilterField {
    MARKETPLACE = "MARKETPLACE",
    LANGUAGE = "LANGUAGE",
    VERTICAL = "VERTICAL",
    SUBVERTICAL = "SUBVERTICAL",
    AD_ACTIVATION_CHANNEL = "AD_ACTIVATION_CHANNEL",
    AD_PRODUCTS_AND_FORMATS = "AD_PRODUCTS_AND_FORMATS",
    PRIMARY_CONTENT_CREATOR_TEAM = "PRIMARY_CONTENT_CREATOR_TEAM",
    MARKETING_STRATEGY = "MARKETING_STRATEGY",
    SEASONAL_EVENTS = "SEASONAL_EVENTS",
    ADVERTISER_GOAL = "ADVERTISER_GOAL",
    FILE_TYPE = "FILE_TYPE",
}

export type MarketingNarrativesFieldSelections = {
    [key in MarketingNarrativesFilterField]: Item[];
};
export type MarketingNarrativesFilterOptions = {
    [key in MarketingNarrativesFilterField]: Item[];
};

export const MarketingNarrativesLastModifiedDate = "LAST_MODIFIED_DATE";
export const MarketingNarrativesTotalViews = "VIEWS";
export const MarketingNarrativesTotalDownloads = "DOWNLOADS";
export const MarketingNarrativeContentOwners = "OWNERS";
